import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { PluginProvider } from './context/PluginContext';

ReactDOM.render(
  <Provider store={store}>
    <PluginProvider>
      <App />
    </PluginProvider>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
